import { Col, Div, Row } from "@/styles/layout";
import { Body, Heading } from "@/styles/typography";
import { ReactNode } from "react";
import { IconType } from "react-icons";

const Card = ({
  name,
  header,
  description,
  children,
  Icon,
  iconColor,
  fill = true,
  boxShadow = "s",
  bg = "primary.bgBase",
}: {
  name?: string;
  header: string;
  description?: string;
  children?: ReactNode;
  Icon?: IconType;
  iconColor?: string;
  fill?: boolean;
  boxShadow?: string;
  bg?: string;
}) => (
  <Col gridArea={name} alignItems={"stretch"} width="100%">
    <Col
      bg={bg}
      borderRadius="10px"
      p="16px"
      boxShadow={boxShadow}
      height={fill ? "100%" : "auto"}
      alignItems={"stretch"}
    >
      <Row alignItems={"center"} mb={description ? "8px" : "16px"}>
        {!!Icon && (
          <Div color={iconColor ?? "primary.textHigh"} mr="12px">
            <Icon size={20} />
          </Div>
        )}
        <Heading fontSize="18px" fontWeight="600">
          {header}
        </Heading>
      </Row>

      {!!description && (
        <Body fontSize="14px" fontWeight="300" mb="16px">
          {description}
        </Body>
      )}
      <Col>{children}</Col>
    </Col>
  </Col>
);

export default Card;
